import { cn } from "@/lib/utils";

interface AvatarProps {
  src: string;
  decoration?: string;
  size?: number;
  className?: string;
  rounded?: boolean;
}

export const AvatarBorder: React.FC<AvatarProps> = ({
  src,
  decoration,
  size,
  className,
  rounded = false,
}) => {
  return (
    <div
      className={cn(`relative overflow-hidden`, className)}
      style={{ width: size, height: size }}
    >
      {/* Avatar */}
      <img
        src={src}
        alt="avatar"
        width={size}
        height={size}
        draggable={false}
        style={{
          position: "absolute",
          top: `calc(${size}px * 0.09)`,
          left: `calc(${size}px * 0.09)`,
          width: `calc(${size}px * 0.82)`,
          height: `calc(${size}px * 0.82)`,
          ...(decoration && { borderRadius: "8px" }),
          ...(!decoration && {
            clipPath: `polygon(
            /* top-left corner */
            0% 10%, 5% 10%, 5% 5%, 10% 5%, 10% 0%,
            /* top-right corner */
            90% 0%, 90% 5%, 95% 5%, 95% 10%, 100% 10%,
            /* bottom-right corner */
            100% 90%, 95% 90%, 95% 95%, 90% 95%, 90% 100%,
            /* bottom-left corner */
            10% 100%, 10% 95%, 5% 95%, 5% 90%, 0% 90%
            )`,
          }),
        }}
        className={rounded ? "rounded-full!" : ""}
      />

      {/* Decoration overlay (optional) */}
      {decoration && (
        <img
          src={decoration}
          alt="decoration"
          width={size}
          height={size}
          draggable={false}
          className={"absolute inset-0 top-0 left-0"}
          style={{
            // position: "absolute",
            // top: 0,
            // left: 0,
            imageRendering: "pixelated",
          }}
        />
      )}
    </div>
  );
};
